// Add to this as needed
export const featureCodes = {
  users: 1,
  administrators: 2,
  remoteUnlock: 3,
  guestPass: 4,
  schedules: 5,
  lockdown: 7,
  apiIntegration: 8,
  wiegandRelay: 10,
  directorySync: 11,
  webHooks: 12,
  customEntryStates: 14,
  singleSignOn: 16,
  lifetimeWarranty: 18,
  subOrgs: 19,
  entries: 20,
  elevatorIoBoards: 21,
  vms: 22,
  advancedAlerts: 23,
  advancedReports: 24,
  customFields: 25,
  customAgreements: 26,
  granularPermissions: 27,
  dynamicPermissions: 28,
  basicRulesEngine: 30,
  advancedRulesEngine: 31,
  azureIdentityProvider: 32,
  oktaIdentityProvider: 33,
  oneloginIdentityProvider: 34,
  gsuiteIdentityProvider: 35,
  fifteenMinSync: 37,
  groupImportFilter: 38,
  manualPrivacyManagement: 39,
  automatedPrivacyManagement: 40,
  userEmailSupport: 41,
  userPhoneSupport: 42,
  syncAudit: 43,
  syncNotification: 44,
  customRetention: 45,
  forensicReporting: 46,
  userManagementUsers: 47,
  occupancyManagement: 48,
  presence: 50,
  merakiCameras: 51,
  merakiVms: 52,
  basicTechSupport: 53,
  premiumTechSupport: 54,
  enterpriseTechSupport: 55,
  standardServiceLevelAgreement: 56,
  apiIntegrationCS: 57,
  customDashboards: 58,
  allegionNdebLeb: 59,
  badgePrinting: 60,
  allegionNdebLebNonOp: 61,
  cloudVideoStorage30: 62,
  cloudVideoStorage60: 63,
  cloudVideoStorage90: 64,
  cloudVideoStorage180: 65,
  scheduledReports: 66,
  gSuiteUsers: 67,
  activeDirectoryUsers: 68,
  oktaUsers: 69,
  oneLoginUsers: 70,
  appMarketplace: 71,
  voiceAssistant: 72,
  workdayIdentityProvider: 73,
  workdayUsers: 74,
  alarmConfigurations: 75,
  openAlarms: 76,
  alarmRateLimit: 77,
  musterReport: 78,
  staticCloud: 79,
  alarmManagement: 80,
  subOrgsVideo: 81,
  occupancyReport: 82,
  samlSso: 83,
  samlJitIdentityProvider: 84,
  raveAlert: 85,
  arizeBuildings: 86,
  courtReserve: 87,
  userSitePartitioning: 88,
  events2hvac: 89,
  idelerTime: 90,
  elevatedLiving: 91,
  yourGolfBooking: 92,
  mobileCredentials: 93,
  equiem: 94,
  smartSpaces: 95,
  hapana: 96,
  yardiBluepoint: 97,
  yellowbox: 98,
  immixProtect: 99,
  flashParking: 100,
  everbridge: 101,
  robinPowered: 102,
  communico: 103,
  invisit: 104,
  mobileWallet: 105,
  readerlessEntries: 110,
  mailroom: 111,
  visitorSmall: 148,
  visitorMedium: 149,
  visitorLarge: 150,
};

// String feature codes (feature.code) for code-based checks
export const featureCodeStrings = {
  intercomDevice: 'intercomDevice',
};
